import { render, staticRenderFns } from "./confirmdds.vue?vue&type=template&id=6d13002c"
import script from "./confirmdds.vue?vue&type=script&lang=js"
export * from "./confirmdds.vue?vue&type=script&lang=js"
import style0 from "./confirmdds.vue?vue&type=style&index=0&id=6d13002c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports